<template>
  <div class="row-v2" id="histories-index">
    <div class="col left">
      <div class="col__box">
        <div v-for="(history, index) in histories.data" class="history-item" :key="history.episode.slug">
          <episode-item-horizontal-component :episode="history.episode" />
          <div>
            <a href="#" @click="deleteHistory(history.id, index)" onclick="return false" :title="`Delete history ${history.episode.name}`"><i class="fa fa-close text-muted fa-1x"></i></a>
          </div>
        </div>
        <div>
          <br>
          <button v-show="histories.last_page != currentPage" type="button" @click="loadMore" class="btn btn-default center-block">Load more</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'history_index',
  data() {
    return {
      histories: {
        data: [],
        last_page: 1000,
      },
      currentPage: 1,
      isLoading: false,
    }
  },
  methods: {
    async loadHistories() {
      this.isLoading = true;
      this.histories = await window.api.history.get({ limit: 25 });
      this.isLoading = false;
    },
    async loadMore() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      var histories = await window.api.history.get({ limit: 25, page: this.currentPage + 1 });
      this.isLoading = false;
      if (histories.data.size() == 0) {
        return;
      }
      this.histories.data.push(...histories.data);
      this.currentPage++;
    },
    async deleteHistory(id, index) {
      await window.api.history[id].delete();
      this.histories.data.splice(index, 1);
    },
  },
  watch: {
    $route() {
      this.loadHistories();
    }
  },
  created() {
    this.loadHistories();
  }
}

</script>
